import styled, { css } from 'styled-components';

export const ImportantStyles = styled.div`
  && {
    /** Box styles */
    ${(props) =>
      props.width &&
      css`
        width: ${props.width} !important;
      `}
    ${(props) =>
      props.height &&
      css`
        height: ${props.height} !important;
      `}
        ${(props) =>
      props.maxWidth &&
      css`
        max-width: ${props.maxWidth} !important;
      `}
        ${(props) =>
      props.maxHeight &&
      css`
        max-height: ${props.maxHeight} !important;
      `}
        ${(props) =>
      props.opacity &&
      css`
        opacity: ${props.opacity} !important;
      `}

        /** Font styles */
        ${(props) =>
      props.fontFamily &&
      css`
        font-family: ${props.fontFamily} !important;
      `}
        ${(props) =>
      props.fontSize &&
      css`
        font-size: ${props.fontSize} !important;
      `}
        ${(props) =>
      props.fontWeight &&
      css`
        font-weight: ${props.fontWeight} !important;
      `}
        ${(props) =>
      props.lineHeight &&
      css`
        line-height: ${props.lineHeight} !important;
      `}
        ${(props) =>
      props.fontSmoothing &&
      css`
        -webkit-font-smoothing: ${props.fontSmoothing} !important;
      `}
        ${(props) =>
      props.textDecoration &&
      css`
        text-decoration: ${props.textDecoration} !important;
      `}
        ${(props) =>
      props.color &&
      css`
        color: ${props.color} !important;
      `}

        /** Hover styles */
        &:hover {
      ${(props) =>
        props.hoverTextDecoration &&
        css`
          text-decoration: ${props.hoverTextDecoration} !important;
        `}
    }
  }
`;
